import {
  type PersonSportRankingResponseRelatedRankingResponseRelatedPagedData,
  type RankingResponse,
} from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import { slugify } from '@on3/ui-lib/utils/slugify';
import clsx from 'clsx';
import { PlayerRanking } from '@public/components/Player/RankingsModule/PlayerRanking';

import styles from './PlayerRankingsModule.module.scss';

interface IPlayerRankingModuleProps {
  playerRankings: PersonSportRankingResponseRelatedRankingResponseRelatedPagedData;
  title?: string;
  isModule?: boolean;
}

export const PlayerRankingsModule = ({
  playerRankings,
  title = 'Player Rankings',
  isModule = false,
}: IPlayerRankingModuleProps) => {
  const { formatHref } = useDynamicRoute();
  const playerRankingsList = playerRankings?.list ?? [];
  const rankingsModel =
    playerRankings.relatedModel?.ranking ?? ({} as RankingResponse);
  const isStateRankings = !!playerRankings.relatedModel?.state;

  return (
    <section className={clsx(styles.block, { [styles.module]: isModule })}>
      <h3>{title}</h3>
      <ol className={styles.playerRankingsList}>
        {playerRankingsList.map((item) => (
          <li key={item.key}>
            <PlayerRanking {...item} useStateRanking={isStateRankings} />
          </li>
        ))}
      </ol>
      <footer className={styles.footer}>
        <Link
          className={styles.viewAll}
          href={formatHref({
            path: `/rivals/rankings/industry-player/[sport]/[year]/`,
            params: {
              sport: slugify(rankingsModel.sport?.name),
              year: String(rankingsModel?.year),
            },
          })}
        >
          View All
        </Link>
      </footer>
    </section>
  );
};
